import { mapGetters } from 'vuex';

export default {
  created() {
    const unwatch = this.$store.watch(
      (_, getters) => getters['partnersListModule/getPartnersList'],
      (newVal) => {
        if (newVal) {
          newVal.forEach(partner => {
            this.partnerFilterOptions.push({
              id: partner.id,
              name: partner.fullName,
              event: `products-filter-partner-${partner.id}`,
              options: {
                type: 'checkbox',
                multiselect: true,
              }
            });

            this.$eventBus.$on(
              `products-filter-partner-${partner.id}`,
              (item) => {
                // HACK: For select partner while main partner is selected
                if (this.getCurrentUserId === this.getActiveFilters?.partner) {
                  this.setSelectedFilter('partner', null, false, false);
                }

                this.setSelectedFilter('partner', item.id, item?.options?.multiselect || false);
              }
            );
          });

          unwatch();
        }
      }
    );
  },
  computed: {
    ...mapGetters('currentUserModule', ['getCurrentUserId']),
    ...mapGetters('statisticPartnersModule', ['getActiveFilters']),
    ...mapGetters('partnersListModule', ['getPartnersList']),
  },
  beforeDestroy() {
    this.getPartnersList.forEach(partner => {
      this.$eventBus.$off(
        `products-filter-partner-${partner.id}`,
        (item) => { this.setSelectedFilter('partner', item.id, item?.options?.multiselect || false); }
      );
    });
  }
};
